export default __webpack_public_path__ + "static/media/13_trang.3ddce761.jpg";